import { Type } from "class-transformer";
import { Adjuster} from "./adjuster";
import { Carrier } from "./carrier";
import { Party } from "@harlowe/core";

export interface ClaimAdjusterNotification
{
    adjusterId: number;
    claimId?: number;
}

export interface ITealCompClaim
{
    id?: number;
    claimNumber: string;
    party: Party;
    claimDate: Date;
    lineOfBusiness: string;
    adjuster?: Adjuster;
    adjuster2?: Adjuster;
    adjusterSupervisor?: Adjuster;
    adjustersToNotify?: ClaimAdjusterNotification[];
    carrier?: Carrier;
    accidentDescription?: string;
    injuryDescription?: string;
    bodyPart?: string;
    caseManager?: string;
    contactInfo?: string;
}

export class TealCompClaim implements ITealCompClaim
{
    constructor
    (
        public id: number,
        public claimNumber: string,
        party: Party,
        public claimDate: Date,
        public lineOfBusiness: string
    )
    {
        this.party = party;
        this.lineOfBusiness = "Work_Comp";
    }


    @Type(() => Party)
    party: Party;
    
    adjuster?: Adjuster;
    adjuster2?: Adjuster;
    adjusterSupervisor?: Adjuster;
    adjustersToNotify?: ClaimAdjusterNotification[];
    carrier?: Carrier;
    accidentDescription?: string;
    injuryDescription?: string;
    bodyPart?: string;
    caseManager?: string;
    contactInfo?: string;

    get displayName() : string
    {
        return this.claimNumber + " " + this.claimDate.toLocaleDateString();
    }

    get adjustersToNotifyIds() : number[]
    {
        if(!this.adjustersToNotify || !Array.isArray(this.adjustersToNotify))
            return [];

        const assignedAdjusterIds = new Set<number>();
        if(this.adjuster?.id) assignedAdjusterIds.add(this.adjuster.id);
        if(this.adjuster2?.id) assignedAdjusterIds.add(this.adjuster2.id);
        if(this.adjusterSupervisor?.id) assignedAdjusterIds.add(this.adjusterSupervisor.id);

        return this.adjustersToNotify
            .map(n => n.adjusterId)
            .filter(id => assignedAdjusterIds.has(id));
    }
}

export class TealCompClaimUpdate
{
    constructor
    (
        public id:number
    )
    {

    }
    claimNumber?:string;
    partyId?: number;
    claimDate? : Date;
    lob? : string;
    adjusterId? : number;
    adjuster2Id?: number;
    adjusterSupervisorId?: number;
    adjustersToNotify?: number[];
    carrierId? : number;
    accidentDescription?: string;
    injuryDescription? : string;
    bodyPart? : string;
    caseManager? : string;
    contactInfo? : string;
}

export class TealCompClaimInsert
{

    constructor
    (
        public claimNumber: string,
        public partyId: number,
        public claimDate: Date,
    )
    {
    }
    
    adjusterId?: number;
    adjuster2Id?: number;
    adjusterSupervisorId?: number;
    adjustersToNotify?: number[];
    carrierId?: number;
    injuryDescription?: string;
    accidentDescription?: string;
    bodyPart?: string;
    caseManager?: string;
    contactInfo?: string;

}
